import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { SocialDemographicsV3Component } from '../social-demographics-v3/social-demographics-v3.component';

HighchartsBorderRadius(Highcharts);

@Component({
	selector: 'app-demographics-v5',
	styleUrls: ['./demographics-v5.component.css'],
	templateUrl: './demographics-v5.component.html'
})
export class DemographicsV5Component extends SocialDemographicsV3Component implements OnInit {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;
	public chartObj: any;
	public totalOfSelectedLegendItem = 0;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	ngAfterContentChecked(): void {
		jQuery('.item_selected').css({ color: this.colorPalette.primaryColor });
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length) {
				this.hasData = true;
				this.creativeData = response.data;
				this.processResponseData();
				this.drawGraph();
			} else {
				this.hasData = false;
			}
		});
	}

	processSelectedLegendItem(legendItem: any): void {
		this.showLoad = true;
		this.selectedLegend = legendItem.value;
		this.graphSeriesData = [];
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}
		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		this.currentIndex = _.findIndex(this.legend, (item: any) => this.selectedLegend === item.value);
		selectedLegend.selected = true;
		this.getCurrentGraphObject(this.currentIndex);
		this.drawGraph();
		this.showLoad = false;
	}

	drawGraph(): void {
		const series = [];
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		const updatedCategories = this.currentGraphData[0].categories.map((category) => {
			if (category === '13-17') {
				return 'Under 18';
			} else {
				return category;
			}
		});
		this.totalOfSelectedLegendItem = 0;
		for (let index = 0; index < this.currentGraphData.length; index++) {
			delete this.currentGraphData[index].series.events;
			series.push(this.currentGraphData[index].series);
			this.totalOfSelectedLegendItem += parseInt(series[index].name.split('|')[1].trim().replace(/,\s?/g, ''), 10);
		}
		this.chartObj = Highcharts.chart({
			chart: {
				backgroundColor: '#374047',
				height: 312,
				marginBottom: 90,
				renderTo: this.graphElement.nativeElement,
				style: {
					color: '#ffffff !important'
				},
				type: 'column'
			},
			colors: [self.colorPalette.primaryColor, self.colorPalette.secondaryColor, self.colorPalette.tertiaryColor],
			credits: {
				enabled: false
			},
			legend: {
				align: 'center',
				itemDistance: 30,
				itemHoverStyle: {
					color: '#ffffff'
				},
				itemStyle: {
					color: '#ffffff'
				},
				verticalAlign: 'bottom',
				labelFormatter(): string {
					return `${this.name.split('|')[0]}`;
				},
				y: 20
			},
			plotOptions: {
				column: {
					borderWidth: 0,
					pointWidth: 5
				}
			},
			series: this.updateBorders(series),
			title: {
				text: null
			},
			tooltip: {
				backgroundColor: '#fff',
				borderRadius: 10,
				style: {
					color: '#2e2e2e'
				},
				useHTML: true,
				formatter(): string {
					return `<div style="width: 130px; text-align:center; padding: 2px; font-size: 1em">
					<div style="display: flex; align-items: center; padding-left: 25%">
						<svg width='20' height='20'>${this.point.series['legendSymbol'].element.outerHTML}</svg>
						<b>${this.point.series['legendItem'].textStr.split('|')[0]}</b>
					</div>
					<div style="padding: 2px">
						<div style="padding-top:5px">
						<div style="text-align:left; width: 50%; display: inline-block; font-size: 0.8em">${self.updateTooltipName()}</div>
						<div style="text-align:right; width: 50%; display: inline-block; font-size: 1em"><b>${self.changeNumberFormat(
							this.y
						)}</b></div><br/>
						</div>
						<div style="padding-top:10px">
						<div style="text-align:left; width: 50%; display: inline-block; font-size: 0.8em">% of Age Group</div>
						<div style="text-align:right; width: 50%; display: inline-block; font-size: 1em"><b>${self.getAgeGroupPercentage(
							this.series.name,
							this.y
						)}</b></div>
						</div>
					</div>
					</div>`;
				}
			},
			xAxis: {
				categories: updatedCategories,
				labels: {
					style: {
						color: '#f9f7f6'
					},
					x: 0,
					y: -20
				},
				offset: 50,
				tickLength: 0,
				title: {
					text: null
				}
			},
			yAxis: {
				gridLineWidth: 0,
				labels: {
					enabled: false
				},
				minorGridLineWidth: 0,
				title: {
					text: null
				}
			}
		});
	}

	updateBorders(series: any[]): any[] {
		series.map((value) => {
			value['borderRadiusTopLeft'] = '50%';
			value['borderRadiusTopRight'] = '50%';
			value['borderRadiusBottomLeft'] = '50%';
			value['borderRadiusBottomRight'] = '50%';
		});
		return series;
	}

	// tslint:disable-next-line: variable-name
	changeNumberFormat(number: any): string {
		return Highcharts.numberFormat(number, 0, '.', ',');
	}

	updateTooltipName(): string {
		const legend: any = _.findWhere(this.legend, { value: this.selectedLegend });
		return legend.displayName;
	}

	getAgeGroupPercentage(fullSeriesName: string, currentVal: number): string {
		this.totalOfSelectedLegendItem = 0;
		const seriesTotal = parseInt(fullSeriesName.split('|')[1].trim().replace(/,\s?/g, ''), 10);
		const percentage = (currentVal / seriesTotal) * 100;
		return `${percentage.toFixed(2)}%`;
	}
	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
